(function () {
	'use stric';

	angular
		.module('processStep.components', [])
		.component('processStep', {
			templateUrl: 'ng/components/processStep/processStep.view.html',
			bindings: {
				current: '<',
				total: '<'
			},
			controllerAs: 'ProcessStepCtrl',
			controller: ProcessStepController
		});

	function ProcessStepController() {}

})()



